import React, { useCallback } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import tinycolor from "tinycolor2";
import { CColorPickerDropdown, CFontIcon } from "@appcues/component-library";

const ThemeColorPicker = ({ label, draftTheme, setDraftTheme }) => {
  const handleChange = useCallback(
    value => {
      const labelName = label.name;
      setDraftTheme(prevDraftTheme => {
        return { ...prevDraftTheme, [labelName]: value.hex };
      });
    },
    [setDraftTheme]
  );

  return (
    <CColorPickerDropdown
      colorState={draftTheme[label.name]}
      onChange={handleChange}
      marginRight={24}
      width={168}
    >
      {label.type === "textcolorpicker" && (
        <StyledFontIcon
          className="fas fa-font"
          currentColor={draftTheme[label.name]}
        />
      )}
    </CColorPickerDropdown>
  );
};

const StyledFontIcon = styled(CFontIcon)`
  .svg-inline--fa {
    path {
      stroke: gray;
      stroke-width: ${props =>
        tinycolor(props.currentColor).isLight() ? "15px" : 0};
    }
  }
`;

ThemeColorPicker.propTypes = {
  label: PropTypes.object.isRequired,
  draftTheme: PropTypes.object.isRequired,
  setDraftTheme: PropTypes.func.isRequired
};

export default ThemeColorPicker;
